/* global indexUrl updateUrl listUrl eventsUrl */
/* global isSuperAdmin subscriptionPlans editablePlansIds */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SaveOrganisationForm from './SaveOrganisationForm';
import SaveOrganisationModulesForm from './SaveOrganisationModulesForm';

import TextButton from 'CommonComponents/TextButton';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

import { useToast } from 'Hooks/useToast';

import ChevronLeftIcon from 'Assets/icons/chevron-left.svg';
import ChevronRightIcon from 'Assets/icons/chevron-right.svg';

export default function OrganisationSettingsIndex(props) {
    const [organisation, setOrganisation] = useState(null);
    const [canEdit, setCanEdit] = useState(false);
    const [canEditDetails, setCanEditDetails] = useState(false);
    const [canSetMfa, setCanSetMfa] = useState(false);
    const [canManageModules, setCanManageModules] = useState(false);
    const [timeKeepingSettings, setTimeKeepingSettings] = useState(null);
    const [currencies, setCurrencies] = useState([]);
    const [error, setError] = useState(null);
    const [request, setRequest] = useState(false);

    const toast = useToast();

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('success')) {
            toast.success($t('The organisation updated successfully'));
            window.history.replaceState({}, '', window.location.pathname);
        }
    }, []);

    const fetchData = () => {
        setRequest(true);

        axios
            .get(props.fetchUrl)
            .then((res) => {
                const { data } = res;
                setOrganisation(data.organisation);
                setCanEdit(data.canEdit);
                setCanEditDetails(data.canEditDetails);
                setCanSetMfa(data.canSetMfa);
                setCanManageModules(data.canManageModules);
                setTimeKeepingSettings(data.timeKeepingSettings);
                setCurrencies(data.currencies || []);
            })
            .catch((e) => {
                console.log(e);
                setError($t('Something went wrong'));
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const postSaveHandler = () => {
        toast.success($t('The organisation updated successfully'));
        fetchData();
    };

    return (
        <div className="tw-space-y-4">
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="tw-flex tw-justify-between">
                <div className="">
                    <a href={props.listUrl}>
                        <TextButton variant="primary">
                            <ChevronLeftIcon className="tw-h-2 tw-w-2" />
                            {$t('Organisations')}
                        </TextButton>
                    </a>
                </div>
                <div className="">
                    <a href={props.eventsUrl}>
                        <TextButton variant="primary">
                            {$t('Projects')}
                            <ChevronRightIcon className="tw-h-2 tw-w-2" />
                        </TextButton>
                    </a>
                </div>
            </div>

            <div>
                {organisation && (
                    <SaveOrganisationForm
                        saveOrganisationUrl={props.updateUrl}
                        postSaveHandler={postSaveHandler}
                        cancelHandler={() => {}}
                        name={organisation.name}
                        financialMonth={organisation.financial_month}
                        financialDay={organisation.financial_day}
                        maxEventsNumber={organisation.max_events_number}
                        maxSeats={organisation.max_seats}
                        subscriptionPlans={props.subscriptionPlans}
                        subscription_plan_id={organisation.subscription_plan_id}
                        action={'edit'}
                        canEdit={canEdit}
                        canEditDetails={canEditDetails}
                        mfaRequired={organisation.mfa_required || false}
                        marginDisplayBasis={organisation.margin_display_basis}
                        loginRetentionMonths={organisation.login_retention_months}
                        canSetMfa={canSetMfa}
                        currencies={currencies}
                        currencyId={organisation.currency_id}
                        canChangePlan={props.isSuperAdmin}
                        editablePlansIds={props.editablePlansIds}
                    />
                )}
            </div>

            {organisation && canManageModules && (
                <SaveOrganisationModulesForm
                    saveModulesUrl={props.modulesUpdateUrl}
                    postSaveHandler={postSaveHandler}
                    timeKeepingEnabled={organisation.time_keeping_enabled || false}
                    timeKeepingSettings={timeKeepingSettings}
                />
            )}
        </div>
    );
}

if (document.getElementById('OrganisationSettings')) {
    var rootEl = document.getElementById('OrganisationSettings');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <OrganisationSettingsIndex
                    fetchUrl={indexUrl}
                    updateUrl={updateUrl}
                    modulesUpdateUrl={rootEl.getAttribute('data-modules-update-url')}
                    listUrl={listUrl}
                    eventsUrl={eventsUrl}
                    isSuperAdmin={isSuperAdmin}
                    subscriptionPlans={subscriptionPlans}
                    editablePlansIds={editablePlansIds}
                />
            </ConfirmationModalProvider>
        </App>,
        rootEl,
    );
}
